<template>
  <div>
    <b-container fluid>
      <b-row style="margin-bottom: 5px;">
        <b-col cols="auto">
          查詢起訖時間:
        </b-col>
        <b-col cols="10">
          <b-input-group style="width: 20vh;display: inline-flex;">
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <!-- <datepicker
              v-model="timepicker.minvalue"
              style="width: 13vh;"
              min="1960-01-01"
              :max="twtimeparse(timepicker.maxvalue)"
            ></datepicker> -->
            <b-form-select
              v-model="fruit.timeSelections.start.selected"
              :options="fruit.timeSelections.start.options"
              @change="getTheMarketByYear"
            ></b-form-select>
          </b-input-group>
          <span style="display: inline-flex; margin-right: 1rem">~</span>
          <b-input-group
            style="width: 20vh;display: inline-flex; margin-right: 1rem;"
          >
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <b-form-select
              v-model="fruit.timeSelections.end.selected"
              :options="fruit.timeSelections.end.options"
              @change="getTheMarketByYear"
            ></b-form-select>
            <!-- <datepicker
              v-model="timepicker.maxvalue"
              style="width: 13vh;"
              :min="twtimeparse(timepicker.minvalue)"
              :max="timepicker.max"
            ></datepicker> -->
          </b-input-group>
          <template v-if="ifloading">
            <b-spinner
              style="width: 1.5rem; height: 1.5rem;"
              variant="success"
              label="Spinning"
            />
          </template>
        </b-col>
      </b-row>
      <b-row
        v-show="fruit.fruitlist.items.length > 0"
        style="margin-bottom: 5px;"
      >
        <b-col cols="auto">
          市場作物:
        </b-col>
        <b-col cols="10">
          <v-select
            style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
            v-show="fruit.fruitlist.items.length > 0"
            v-model="fruit.fruitlist.value"
            :options="fruit.fruitlist.options"
            :selectable="(car) => car.disabled"
          ></v-select>
        </b-col>
      </b-row>
      <div v-show="fruit.marketlist.options.length > 0">
        <b-row style="margin-bottom: 5px;">
          <b-col cols="auto">
            交易市場名稱:
          </b-col>
          <b-col cols="10">
            <b-form-checkbox-group
              id="checkbox-group-3"
              v-show="fruit.marketlist.options.length > 0"
              v-model="fruit.marketlist.value"
              :options="fruit.marketlist.options"
              :state="state"
            >
              <b-form-invalid-feedback :state="state"
                >請勿選超過3個市場</b-form-invalid-feedback
              >
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <template v-if="fruit.marketlist.value.length > 0">
          <b-row style="margin-bottom: 5px;">
            <b-col cols="auto">
              產地價格:
            </b-col>
            <b-col cols="10">
              <b-form-checkbox
                id="checkbox3-1"
                v-show="fruit.marketlist.options.length > 0"
                v-model="fruit.averageprice"
                :value="true"
                :unchecked-value="false"
                >嘉義縣產地均價</b-form-checkbox
              >
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 15px;">
            <b-col cols="auto">
              價格監控:
            </b-col>
            <b-col cols="10">
              <b-form-checkbox
                id="checkbox3-2"
                v-show="fruit.marketlist.options.length > 0"
                v-model="fruit.maintainprice"
                :value="true"
                :unchecked-value="false"
                >農糧署產地價格監控</b-form-checkbox
              >
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 5px;">
            <b-col>
              <b-form-checkbox
                id="checkbox3-3"
                v-show="fruit.obj.chart.options.yaxis.length > 0"
                v-model="dataLabels"
                :value="true"
                :unchecked-value="false"
                >顯示數值標籤
              </b-form-checkbox>
            </b-col>
          </b-row>
        </template>
      </div>
    </b-container>
    <!-- <template v-if="ifloading">
      <b-spinner
        style="width: 1.5rem; height: 1.5rem;"
        variant="success"
        label="Spinning"
      />
    </template>
    <template v-else> -->
    <div style="width: 100%; overflow-x: scroll;">
      <apexchart
        ref="chart1ref"
        height="450"
        type="line"
        :options="fruit.obj.chart.options"
        :series="fruit.obj.chart.series"
      ></apexchart>
    </div>
    <!-- </template> -->
    <div>※值為0代表無資料</div>
  </div>
</template>

<script>
import CROPCODELIST from "@/data/CROP_CODE_LIST.json";
// import datepicker from "@/components/DatepickerForMonth.vue";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    //var thisyear = now.getFullYear();
    const maxDate = new Date(today);
    // maxDate.setDate(date.getDate() + 1);
    const minDate = new Date(today);
    //minDate.setDate(date.getDate() - 30);
    minDate.setDate(date.getDate() - 365);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate.pop();
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    // taiwanMinDate[2] =
    //   taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate.pop();
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    // taiwanMaxDate[2] =
    //   taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      dataLabels:true,
      fruit: {
        fruitlist: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
          items: [],
        },
        marketlist: {
          value: [],
          options: [],
          allitems: [],
          items: [],
        },
        timeSelections: {
          start: {
            selected: null,
            options: [],
          },
          end: {
            selected: null,
            options: [],
          },
        },
        mainlist: [],
        iffirst: true,
        ifchartshow: false,
        averageprice: false,
        maintainprice: false,
        overylayshow: true,
        selectlist: [0, "梨子", null],
        typeoptionslist: [
          { text: "請選擇種類", value: null, disabled: true },
          { text: "水果", value: 0 },
          { text: "蔬菜", value: 1 },
          { text: "雜糧特作", value: 2 },
        ],
        options: [
          { text: "請選擇作物", value: null },
          { text: "梨子", value: "梨子" },
          { text: "木瓜", value: "木瓜" },
          { text: "鳳梨", value: "鳳梨" },
        ],
        obj: {
          chart: {
            series: [],
            options: {
              chart: {
                height: 450,
                type: "line",
                zoom: {
                  enabled: false,
                },
              },
              title: {
                text:  "",
              },
              dataLabels: {
                enabled: true,
              },
              stroke: {},
              // stroke: {
              //   show: true,
              //   width: [],
              //   curve: "straight",
              //   dashArray: [],
              // },
              noData: {
                text: "請選擇市場作物",
                align: "center",
                verticalAlign: "middle",
              },
              labels: [],
              yaxis: [],
              colors: [
                "#33a5fb",
                "#775dd0",
                "#1c22ce",
                "#ff7b3d",
                "#f9b5c0",
                "#4c1a11",
                "#6f5c5d",
                "#88715c",
                "#86a3be",
                // "#008FFB",
                // "#19535f",
                // "#FEB019",
                // "#FF4560",
                // "#775DD0",
                // "#1c22ce",
                // "#ff7b3d",
                // "#f9b5c0",
                // "#4c1a11",
              ],
              // xaxis: {
              //   type: "datetime",
              //   labels: {
              //     formatter: function(value, timestamp) {
              //       var date = new Date(timestamp);
              //       if (date.getFullYear() < 1975) return;
              //       var year = date.getFullYear() - 1911;
              //       return (
              //         year + "/" + (date.getMonth() + 1) + "/" + date.getDate()
              //       ); // The formatter function overrides format property
              //     },
              //   },
              // },
              // xaxis: {
              //   type: "datetime",
              //   labels: {
              //     formatter: function(value, timestamp) {
              //       var date = new Date(timestamp);
              //       if (date.getFullYear() < 1975) return;
              //       var year = date.getFullYear() - 1911;
              //       return (
              //         year + "/" + (date.getMonth() + 1) + "/" + date.getDate()
              //       ); // The formatter function overrides format property
              //     },
              //   },
              // },
              plotOptions: {
                bar: {
                  columnWidth: "20%",
                },
              },
              grid: {
                padding: {
                  right: 10,
                  left: 10,
                },
              },
            },
          },
        },
        countryoptions: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: {
                position: "top",
              },
            },
          },
          title: {
            text: "108年各縣市 種植面積",
          },
          tooltip: {
            shared: true,
            intersect: false,
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: [
              "台中市",
              "台北市",
              "台東縣",
              "台南市",
              "宜蘭縣",
              "花蓮縣",
              "南投縣",
              "屏東縣",
              "苗栗縣",
              "桃園市",
              "高雄市",
              "雲林縣",
              "新北市",
              "新竹縣",
              "嘉義縣",
              "彰化縣",
            ],
          },
          yaxis: [
            {
              title: {
                text: "各縣市",
              },
            },
          ],
          // colors: ['#0000ff', '#8a2be2', '#a52a2a', '#deb887', '#5f9ea0', '#7fff00', '#d2691e', '#ff7f50', '#6495ed', '#dc143c', '#00ffff', '#00008b', '#008b8b', '#b8860b', '#006400', '#8b008b']
        },
        charyioptions: {
          chart: {
            // height: 350,
            type: "bar",
          },
          title: {
            text: "108年嘉義 鄉鎮 種植面積",
          },
          tooltip: {
            shared: true,
            intersect: false,
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: [
              "大林鎮",
              "中埔鄉",
              "六腳鄉",
              "太保市",
              "水上鄉",
              "布袋鎮",
              "民雄鄉",
              "朴子市",
              "竹崎鄉",
              "東石鄉",
              "大埔鄉",
              "鹿草鄉",
              "番路鄉",
              "新港鄉",
              "溪口鄉",
              "義竹鄉",
            ],
          },
          yaxis: [
            {
              title: {
                text: "種植面積(公頃)",
              },
            },
          ],
        },
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "產銷儀錶板",
          active: true,
        },
        {
          text: "農產品交易價量分析",
          active: true,
        },
      ],
      ifloading: false,
      cropcodelist: CROPCODELIST,
      // timepicker: {
      //     minvalue: minDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     maxvalue: maxDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     max: maxDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     min: minDate.toLocaleString().split(' ')[0].split('/').join('-')
      // },
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        // minvalue: "110-07-12",
        // maxvalue: "110-07-15",
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
        min: minDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      croplandlist: [],
      apiGetYearListTrade: (data) =>
        this.userRequest.post("/API/Default/getYearListTrade", data),
      apiGetCropForChart: (data) =>
        this.userRequest.post("/API/Default/getCropForYearChart", data),
      apiGetCropFromDate: (data) =>
        this.userRequest.post("/API/Default/getCropFromYear", data),
      apiGetMarketFromCrop: (data) =>
        this.userRequest.post("/API/Default/getMarketFromCropbyYear", data),
    };
  },
  created() {
    this.checkLogin();
    // this.init();
  },
  // components: {
  //   datepicker,
  // },
  computed: {
    state() {
      return this.fruit.marketlist.value.length > 3 ? false : null;
    },
  },
  // mounted(){
  //     // this.FunctionToken(this.getCropLandList, {});

  // },
  watch: {
    "fruit.fruitlist.value"(value) {
      this.getmarketdetial(value.code);
    },
    "timepicker.maxvalue"() {
      if (!this.iffirst)
        // this.updatechart()
        this.init();
    },
    "timepicker.minvalue"() {
      if (!this.iffirst)
        // this.updatechart()
        this.init();
    },
    "fruit.marketlist.value"(value) {
      if (value.length > 0) this.optionscheck();
      else this.chartinit();
    },
    "fruit.averageprice"() {
      this.optionscheck();
    },
    "fruit.maintainprice"() {
      this.optionscheck();
    },
    "dataLabels"(val){
            if(val){
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:true
                    }
                })
            }
            else{
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:false
                    }
                })
            }
            //console.log(this.chartOptions.dataLabels)
    }
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000002", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        // window.addEventListener("resize", this.handleResize);
        // this.handleResize();
        this.init();
      }
    },
    getCropFromDate(data) {
      this.apiGetCropFromDate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.CROP,
                code: x.CROP_CODE,
                disabled: true,
              };
              this.fruit.fruitlist.items.push(obj);
            });
            this.fruit.fruitlist.options = this.fruit.fruitlist.items.slice(0);
            this.fruit.fruitlist.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            let cropname = this.$route.params.Crop;
            if (this.IsNull(cropname) != "") {
              let index = this.fruit.fruitlist.options.findIndex(
                (x) => x.code == cropname.CROP_CODE
              );
              if (index != -1) {
                let subitem = this.fruit.fruitlist.options[index];
                this.fruit.fruitlist.value = {
                  label: subitem.label,
                  code: subitem.code,
                  disabled: false,
                };
                this.getmarketdetial(subitem.code);
              } else {
                this.fruit.fruitlist.value = {
                  label: "請選擇",
                  code: "請選擇",
                  disabled: false,
                };
              }
            } else {
              this.fruit.fruitlist.value = {
                label: "請選擇",
                code: "請選擇",
                disabled: false,
              };
            }
            this.ifloading = false;
            // this.fruit.fruitlist.items = JSON.parse(json.Data)
            // this.createchart()
          }
        })
        .catch((err) => console.warn(err));
    },
    getMarketFromCrop(data) {
      this.apiGetMarketFromCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let arr = JSON.parse(json.Data);
            this.fruit.marketlist.options = [];
            this.fruit.marketlist.value = [];
            this.fruit.averageprice = false;
            this.fruit.maintainprice = false;
            arr.forEach((x) => {
              let obj = {
                text: x.MARKET,
                value: x.MARKET_CODE,
              };
              this.fruit.marketlist.options.push(obj);
            });
            let obj = {
              text: "全國",
              value: "全國",
            };
            this.fruit.marketlist.options.unshift(obj);
            this.ifloading = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    getCropForChart(data) {
      this.apiGetCropForChart(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.fruit.fruitlist.items = JSON.parse(json.Data);
            console.log(this.fruit.fruitlist.items);
            this.createnewchart();
          }
        })
        .catch((err) => console.warn(err));
    },
    chartinit() {
      this.fruit.obj.chart.series = [];
      this.fruit.obj.chart.options.labels = [];
      this.fruit.obj.chart.options.yaxis = [];
      this.fruit.obj.chart.options.xaxis = {};
      this.dataLabels=true;
    },
    init() {
      this.fruit.fruitlist.items = [];
      this.fruit.fruitlist.options = [];
      this.fruit.marketlist.options = [];
      this.fruit.marketlist.value = [];
      this.fruit.averageprice = false;
      this.fruit.maintainprice = false;
      this.ifloading = true;
      this.chartinit();
      this.FunctionToken(this.getYearListTrade, {});
      //let localmintime = this.timepicker.minvalue.split("-");
      //localmintime[0] = parseInt(localmintime[0]) + 1911;
      //let localmaxtime = this.timepicker.maxvalue.split("-");
      //localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      // let diff = Math.floor((Date.parse(localmaxtime.join('-')) - Date.parse(localmintime.join('-'))) / 86400000);

      // if(diff>31)
      // {
      //     alert("時間選擇區間不能超過1個月")
      // }
      // else
      // {
      // let obj = {
      //   start_year: localmintime.join("."),
      //   end_year: localmaxtime.join("."),
      // };
      // this.FunctionToken(this.getCropFromDate, obj);
      // }
    },
    getYearListTrade(data) {
      this.apiGetYearListTrade(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let data = JSON.parse(json.Data);
            console.log(data);
            data.forEach((x) => {
              this.fruit.timeSelections.start.options.push(x.ROC_YEAR);
              this.fruit.timeSelections.end.options.push(x.ROC_YEAR);
            });
            this.fruit.timeSelections.start.selected = this.fruit.timeSelections.start.options[1];
            this.fruit.timeSelections.end.selected = this.fruit.timeSelections.end.options[0];
            let obj = {
              start_year: this.fruit.timeSelections.start.selected,
              end_year: this.fruit.timeSelections.end.selected,
            };
            this.FunctionToken(this.getCropFromDate, obj);
          }
        })
        .catch((err) => console.warn(err));
    },
    getmarketdetial(value) {
      // let localmintime = this.timepicker.minvalue.split("-");
      //localmintime[0] = parseInt(localmintime[0]) + 1911;
      // let localmaxtime = this.timepicker.maxvalue.split("-");
      // //localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      // let diff = Math.floor(
      //   (Date.parse(localmaxtime.join("-")) -
      //     Date.parse(localmintime.join("-"))) /
      //     86400000
      // );

      if (value != "請選擇") {
        this.ifloading = true;
        let obj = {
          start_year: this.fruit.timeSelections.start.selected,
          end_year: this.fruit.timeSelections.end.selected,
          CROP_CODE: value,
        };
        this.FunctionToken(this.getMarketFromCrop, obj);
      }
    },
    getchartdata() {
      if (
        this.fruit.marketlist.value.length > 0 &&
        this.fruit.fruitlist.value.code != "請選擇"
      ) {
        this.ifloading = true;
        // let localmintime = this.timepicker.minvalue.split("-");
        //localmintime[0] = parseInt(localmintime[0]) + 1911;
        // let localmaxtime = this.timepicker.maxvalue.split("-");
        //localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

        let allindex = this.fruit.marketlist.value.findIndex(
          (x) => x == "全國"
        );
        let obj = {};

        if (allindex != -1) {
          let optionlist = [];

          this.fruit.marketlist.options.forEach((x) => {
            optionlist.push(x.value);
          });

          obj = {
            start_year: this.fruit.timeSelections.start.selected,
            end_year: this.fruit.timeSelections.end.selected,
            CROP_CODE: this.fruit.fruitlist.value.code,
            MARKET_CODE: optionlist,
          };
        } else {
          obj = {
            start_year: this.fruit.timeSelections.start.selected,
            end_year: this.fruit.timeSelections.end.selected,
            CROP_CODE: this.fruit.fruitlist.value.code,
            MARKET_CODE: this.fruit.marketlist.value,
          };
        }

        this.FunctionToken(this.getCropForChart, obj);
      }
    },
    getTheMarketByYear() {
      this.fruit.fruitlist.items = [];
      this.fruit.fruitlist.options = [];
      this.fruit.marketlist.options = [];
      this.fruit.marketlist.value = [];
      this.fruit.averageprice = false;
      this.fruit.maintainprice = false;
      this.ifloading = true;
      let obj = {
        start_year: this.fruit.timeSelections.start.selected,
        end_year: this.fruit.timeSelections.end.selected,
      };
      this.FunctionToken(this.getCropFromDate, obj);
    },
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    changetimeformat(time) {
      let tt = time.split("-");
      tt[0] = parseInt(tt[0]) - 1911;
      return tt.join("-");
    },
    optionscheck() {
      if (this.fruit.marketlist.value.length > 3) {
        alert("市場選項已超過3筆，請重新選擇");
      } else {
        this.getchartdata();
      }
    },
    createnewchart() {
      this.fruit.obj.chart.series = [];
      this.fruit.obj.chart.options.labels = [];
      this.fruit.obj.chart.options.yaxis = [];
      let datelist = [];
      let mainlist = [];
      let serieslist = []  , maxprice = 0;

      for (let j in this.fruit.fruitlist.items) {
        let subdate10 = this.fruit.fruitlist.items[j].YEAR;
        if (datelist.indexOf(subdate10) == -1) {
          datelist.push(subdate10);
        }
      }

      //console.log(datelist);

      for (let i in this.fruit.marketlist.value) {
        let list1 = [];
        if (this.fruit.marketlist.value[i] == "全國") {
          for (let i in datelist) {
            let subtime = datelist[i];
            let allavgprice = 0,
              allvolume = 0,
              count1 = 0,
              count2 = 0;
            for (let j in this.fruit.fruitlist.items) {
              let subitem2 = this.fruit.fruitlist.items[j];
              let subtime2 = subitem2.YEAR;
              if (subtime2 == subtime) {
                if (subitem2.PRICE_AVG != 0) {
                  allavgprice = allavgprice + subitem2.PRICE_AVG;
                  count1++;
                }
                if (subitem2.VOLUME != 0) {
                  allvolume = allvolume + subitem2.VOLUME;
                  count2++;
                }
              }
            }
            let avgvalue1 = 0,
              volumevalue1 = 0;
            if (count1 != 0) avgvalue1 = Math.round(allavgprice / count1);
            if (count2 != 0) volumevalue1 = Math.round(allvolume / count2);
            if (avgvalue1 > maxprice) maxprice = avgvalue1;

            let obj1 = {
              date: subtime,
              avgprice: avgvalue1,
              volume: volumevalue1,
            };
            list1.push(obj1);
          }
          let obj2 = { name: "全國", data: list1 };
          mainlist.push(obj2);
        } else {
          let marketindex = this.fruit.marketlist.options.findIndex(
            (x) => x.value == this.fruit.marketlist.value[i]
          );
          let subitem1 = this.fruit.marketlist.options[marketindex].text;
          for (let z in this.fruit.fruitlist.items) {
            let fruititem = this.fruit.fruitlist.items[z];
            if (fruititem.MARKET == subitem1) {
              let fruitSubdate = fruititem.YEAR;
              let obj1 = {
                date: fruitSubdate,
                avgprice: fruititem.PRICE_AVG.toFixed(2),
                volume: fruititem.VOLUME.toFixed(2),
              };
              list1.push(obj1);
              if (fruititem.PRICE_AVG > maxprice) maxprice = fruititem.PRICE_AVG.toFixed(2);
            }
          }
          let obj2 = { name: subitem1, data: list1 };
          mainlist.push(obj2);
        }
      }
      //console.log("maxprice",maxprice);
      maxprice = Math.ceil(maxprice);//小數點無條件進位
      for (let k in mainlist) {
        let element1 = mainlist[k];
        let avglist = [],
          volumelist = [];

        for (let t in datelist) {
          let subdate = datelist[t];
          let subindex = element1.data.findIndex((y) => y.date == subdate);
          if (subindex != -1) {
            let element2 = element1.data[subindex];
            avglist.push(element2.avgprice);
            volumelist.push(element2.volume);
          } else {
            avglist.push(0);
            volumelist.push(0);
          }
        }

        let volumeobj = {
          name: element1.name + "交易均量",
          type: "column",
          data: volumelist,
        };

        serieslist.push(volumeobj);

        let avgobj = {
          name: element1.name + "拍賣均價",
          type: "line",
          data: avglist,
        };

        serieslist.push(avgobj);

        let volumeoption = {},
          avgoption = {};
        if (k == 0) {
          volumeoption = {
            seriesName: "交易均量",
            title: {
              text: "交易均量(公斤)",
            },
          };

          avgoption = {
            seriesName: "拍賣均價",
            opposite: true,
            max: maxprice,
            min: 0,
            labels:{
              formatter: function(val){
                if(window.isNaN(val)) return 0;
                return val.toFixed(2);
              }
            },
            title: {
              text: "價格 ( 元 / 公斤 )",
            },
          };
        } else {
          volumeoption = {
            seriesName: "交易均量",
            show: false,
          };

          avgoption = {
            seriesName: "拍賣均價",
            show: false,
            max: maxprice,
            min: 0,
          };
        }

        this.fruit.obj.chart.options.yaxis.push(volumeoption);
        this.fruit.obj.chart.options.yaxis.push(avgoption);
      }

      if (this.fruit.averageprice || this.fruit.maintainprice) {
        let averagelist2 = [],
          mantainlist2 = [];
        for (let l in datelist) {
          let averagelist3 = [],
            mantainlist3 = [],
            datelist3 = [];
          let dateelement = datelist[l];
          for (let n in this.fruit.fruitlist.items) {
            let subitem5 = this.fruit.fruitlist.items[n];
            let subtime5 = subitem5.YEAR;
            if (
              datelist3.indexOf(subtime5) == -1 &&
              subtime5 == dateelement &&
              subitem5.CROP_CODE == this.fruit.fruitlist.value.code
            ) {
              if (this.fruit.averageprice) {
                let avgprice =
                  (subitem5.CM_PRICE_C +
                    subitem5.CM_PRICE_M +
                    subitem5.CM_PRICE_F) /
                  3;
                averagelist3.push(avgprice);
              }

              if (this.fruit.maintainprice) {
                mantainlist3.push(subitem5.CM_PRICE_MON);
              }
              datelist3.push(subitem5.YEAR);
            }
          }
          let avg2 = 0,
            volume2 = 0,
            avgcounter = 0,
            volumecounter = 0;

          if (this.fruit.averageprice) {
            averagelist3.forEach((y) => {
              if (y != 0) avgcounter++;
              avg2 += y;
            });
            if (avgcounter != 0) {
              let value1 = avg2 / avgcounter;
              averagelist2.push(value1.toFixed(2));
            } else {
              averagelist2.push(0);
            }
          }
          if (this.fruit.maintainprice) {
            mantainlist3.forEach((z) => {
              if (z != 0) volumecounter++;
              volume2 += z;
            });
            if (volumecounter != 0) {
              let value2 = volume2 / volumecounter;
              mantainlist2.push(value2.toFixed(2));
            } else {
              mantainlist2.push(0);
            }
          }
        }

        if (averagelist2.length > 0) {
          let obj = {
            name: "嘉義縣產地均價",
            type: "line",
            data: averagelist2,
          };
          serieslist.push(obj);

          if (this.fruit.obj.chart.options.yaxis.length == 0) {
            let chartoption = {
              seriesName: "拍賣均價",
              opposite: true,
              title: {
                text: "價格 ( 元 / 公斤 )",
              },
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          } else {
            let chartoption = {
              seriesName: "拍賣均價",
              show: false,
              max: maxprice,
              min: 0,
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          }
        }

        if (mantainlist2.length > 0) {
          let obj = {
            name: "農糧署產地價格監控",
            type: "line",
            data: mantainlist2,
          };
          serieslist.push(obj);

          if (this.fruit.obj.chart.options.yaxis.length == 0) {
            let chartoption = {
              seriesName: "拍賣均價",
              opposite: true,
              title: {
                text: "價格 ( 元 / 公斤 )",
              },
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          } else {
            let chartoption = {
              seriesName: "拍賣均價",
              show: false,
              max: maxprice,
              min: 0,
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          }
        }
      }

      this.fruit.obj.chart.series = serieslist;
      this.fruit.obj.chart.options.labels = datelist;

      this.parseSpecificStingToDashed();
      if(this.dataLabels) this.fruit.obj.chart.options.dataLabels.enabled =true;
      else this.fruit.obj.chart.options.dataLabels.enabled =false;
      this.ifloading = false;
      if (this.$refs.chart1ref != undefined) {
        this.$refs.chart1ref.updateSeries(this.fruit.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.fruit.obj.chart.options);
        this.ifloading = false;
        this.$nextTick(() => {
          let markers = document.getElementsByClassName(
            "apexcharts-legend-marker"
          );
          // console.log(markers);
          // markers.forEach((x) => {
          //   console.log(x.nextSibling.innerText);
          // });
          for (let i = 0; i < markers.length; i++) {
            let marker = markers[i];
            // console.log(marker.nextSibling.innerText);
            if (marker.nextSibling && marker.nextSibling.innerText === "全國拍賣均價") {
              marker.outerHTML =
                '<span class="apexcharts-legend-marker" rel="' +
                i +
                1 +
                '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="imgs/line-dash01.svg" /></span>';
            } else if (marker.nextSibling && marker.nextSibling.innerText === "嘉義縣產地均價") {
              marker.outerHTML =
                '<span class="apexcharts-legend-marker" rel="' +
                i +
                1 +
                '" data:collapsed="false" style="width: 30px; border-width: 0px;"><img src="imgs/line-dash02.svg" /></span>';
            }
          }
        });
      }
    },
    parseSpecificStingToDashed() {
      let num = this.fruit.obj.chart.series.length;
      this.fruit.obj.chart.options.stroke = {
        show: true,
        width: new Array(num).fill(2),
        curve: "smooth",
        dashArray: new Array(num).fill(0),
      };
      this.fruit.obj.chart.options.colors = [
        "#33a5fb",
        "#775dd0",
        "#1c22ce",
        "#ff7b3d",
        "#f9b5c0",
        "#4c1a11",
        "#6f5c5d",
        "#88715c",
        "#86a3be",
      ];

      let index1 = this.fruit.obj.chart.series.findIndex(
        (x) => x.name == "全國拍賣均價"
      );
      let index2 = this.fruit.obj.chart.series.findIndex(
        (x) => x.name == "嘉義縣產地均價"
      );
      let index3 = this.fruit.obj.chart.series.findIndex(
        (x) => x.name == "農糧署產地價格監控"
      );

      if (index1 != -1 || index2 != -1 || index3 != -1) {
        if (index1 != -1)
          this.fruit.obj.chart.options.stroke.dashArray[index1] = 15;
        this.fruit.obj.chart.options.colors[index1] = "#19535f";
        if (index2 != -1)
          this.fruit.obj.chart.options.stroke.dashArray[index2] = 35;
        this.fruit.obj.chart.options.colors[index2] = "#feb019";
        if (index3 != -1)
          this.fruit.obj.chart.options.colors[index3] = "#ff4560";
      }
      console.log([
        index1,
        index2,
        index3,
        this.fruit.obj.chart.options.stroke,
        this.fruit.obj.chart.options.colors,
        this.fruit.obj.chart.series,
      ]);
    },
    getnewdate(date, index) {
      let firstdate = date.split("-");
      firstdate[0] = parseInt(firstdate[0]) + 1911;
      let subdate = new Date(firstdate.join("-"));
      if (index == 0) {
        subdate.setDate(subdate.getDate() - 1);
      } else {
        subdate.setDate(subdate.getDate() + 1);
      }
      let formatDate =
        parseInt(subdate.getFullYear()) -
        1911 +
        "-" +
        (subdate.getMonth() + 1) +
        "-" +
        subdate.getDate();
      return formatDate;
    },
    getnewdate2(date) {
      let datelist = [];
      date.forEach((x) => {
        let date = x.split("-");
        date[0] = parseInt(date[0]) - 1911;
        datelist.push(date.join("/"));
      });
      return datelist;
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
  },
};
</script>
